<template>
  <el-container id="ActivityGl">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{ color: l.colour, lineHeight: 0.3 }">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding:15px">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <!--          <p style="margin-left:5px; font-size:18px; font-weight: bold">活动创建与推广</p>-->
          <el-date-picker v-model="ediTime" type="daterange" @change="getActivity()" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          <el-select v-model="ediByPubTime" ref='devSonSelect' @change="getActivity(1)" clearable filterable
                     placeholder="发布时间排序" style="width:8vw;margin-left:5px;">
            <el-option v-for="item in li_ByPubTime" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="ediByTitle" ref='devSonSelect' @change="getActivity(2)" clearable filterable
                     placeholder="标题排序" style="width:8vw;margin-left:5px;">
            <el-option v-for="item in li_ByPubTime" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="ediOline" ref='devSonSelect' @change="getActivity()" clearable filterable
                     placeholder="活动状态" style="width:8vw;margin-left:5px;">
            <el-option v-for="item in liOline" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left:10px;height:40px;" type="primary" @click="onResh" icon="el-icon-refresh">
            重置
          </el-button>
          <span style="margin-left:auto; font-size: 13px">
            <el-input placeholder="搜索活动" style="width:10vw;" prefix-icon="el-icon-search" clearable
                      @change="getActivity()" v-model="ediTitle">
            </el-input>
          </span>
          <el-button @click="onAddActivity" size="small" type="primary" icon="el-icon-plus"
                     style="margin-left:0.5vw;margin-right:10px;font-size:15px;line-height:18px">
            新增活动
          </el-button>
        </div>
        <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px" :max-height=maxHeight
                  show-overflow-tooltip
                  :header-cell-style="{ 'height': '30px', 'text-align': 'center', 'background': '#F4F4F4', 'color': '#0dA7C8' }">
          <el-table-column width="01" sortable/>
          <div v-for="(d, item) in this.defHead">
            <el-table-column v-if="d.key === '活动封面'" :key=item :prop=d.val :label=d.key :width="d.w">
              <template slot-scope="scope">
                <el-image :src="scope.row.imgUrl" style="max-width:107px;height:60px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column v-else :key="'col-' + item" :prop=d.val :label=d.key :width="d.w">
            </el-table-column>
          </div>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <div style="text-align: left;">
                <el-button @click="onChangeActivity(scope.row, 'r')" type="text" size="small"
                           style="color:#4B5563;font-size: 14px">查看
                </el-button>
                <el-button v-if="scope.row.state !== '未开始' && scope.row.state !== '进行中'"
                           @click="onChangeActivity(scope.row, 'w')" type="text" size="small"
                           style="color:#1677FF;font-size: 14px">编辑
                </el-button>
                <el-button v-if="scope.row.state === '未开始' || scope.row.state === '进行中'"
                           @click="upState(scope.row, 1)"
                           type="text" size="small" style="color:#EAB308;font-size: 14px">下线
                </el-button>
                <el-button v-if="scope.row.state === '未开始' || scope.row.state === '进行中'"
                           @click="upState(scope.row, 4)"
                           type="text" size="small" style="color:red;font-size: 14px">取消
                </el-button>
                <el-button v-if="scope.row.state === '未发布'" @click="upState(scope.row, 2)" type="text" size="small"
                           style="color:#22C55E;font-size: 14px">发布
                </el-button>
                <el-button v-if="scope.row.state !== '未开始' && scope.row.state !== '进行中'"
                           @click="onDelActivity(scope.row)" type="text" size="small" style="color:red;font-size: 14px">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="float:right; margin-right:0.5vw;margin-top:5px" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange1" :current-page="page" :page-sizes="[10, 20, 30]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <el-dialog title="删除提示" :visible.sync="daiDelActivity" width="30%">
      <span>确定删除该活动吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelActivity = false">取 消</el-button>
        <el-button type="primary" @click=delUser()>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="取消提示" :visible.sync="daiCleanActivity" width="30%">
      <span>确定取消该活动吗？ 取消后将提前结束。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiCleanActivity = false">取 消</el-button>
        <el-button type="primary" @click=cleanUser()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"ActivityGl",
  components:{ /*引入组件*/

  },
  data(){
    return {
      h_text:"活动管理",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      ediTime:"",
      scan_user:"",
      tabData:[],
      maxHeight:window.innerHeight - 240,
      defHead:[
        // {'key': "置顶", 'val': "isTop", "w": "200px"},
        {'key':"活动封面",'val':"imgUrl","w":"auto"},
        {'key':"活动名称",'val':"title","w":"auto"},
        {'key':"活动时间",'val':"times1","w":"auto"},
        {'key':"发布时间",'val':"times2","w":"auto"},
        {'key':"报名人数",'val':"number","w":"auto"},
        {'key':"编辑人",'val':"user","w":"auto"},
        {'key':"活动状态",'val':"state","w":"auto"}
      ],
      id:1,
      stateId:1,
      page:1,
      pageSize:10,
      total:0,
      ediTitle:"",
      ediByPubTime:"",
      ediByTitle:"",
      li_ByPubTime:[
        {value:1,label:"升序"},
        {value:2,label:"降序"}
      ],
      ediOline:"",
      liOline:[
        {value:1,label:"未发布"},
        {value:2,label:"未开始"},
        {value:3,label:"进行中"},
        {value:4,label:"已取消"},
        {value:5,label:"已结束"}
      ],
      li_user:[],
      daiCleanActivity:false,
      daiDelActivity:false
    };
  },
  methods:{ /*方法存放*/
    tableYs({row,column,rowIndex,columnIndex}){ /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getActivity();
    },
    handleCurrentChange1(val){
      this.page = val;
      this.getActivity();
    },
    onResh(){
      this.ediTime = "";
      this.ediByPubTime = "";
      this.ediByTitle = "";
      this.ediTitle = "";
      this.ediOline = "";
      this.getActivity();
    },
    onAddActivity(){
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsActivityGlSon',
        query:{key:'addActivity'}
      });
    },
    onChangeActivity(row,operate){
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsActivityGlSon',
        query:{
          key:'changeActivity',
          operate:operate,
          id:row.id
        }
      });
    },
    getActivity(fil = null){
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if(fil) {
        if(fil === 1) {
          this.ediByTitle = "";
        } else {
          this.ediByPubTime = "";
        }
      }
      if(this.ediTitle) {
        params["title"] = this.ediTitle; /*标题文字*/
      }
      if(this.ediOline) {
        params["stateId"] = this.ediOline; /*活动状态*/
      }
      if(this.ediByPubTime) {
        params["byPubTime"] = this.ediByPubTime; /*发布时间排序*/
      } else if(this.ediByTitle) {
        params["byTitle"] = this.ediByTitle; /*标题排序*/
      } else {
        params["byPubTime"] = 2;
      }
      if(this.ediTime) {
        console.log(new Date().getTime());
        console.log(this.ediTime[0].getTime() / 1000); /*筛选时间*/
        console.log(this.ediTime[1].getTime() / 1000); /*筛选时间*/
        params['validStart'] = parseInt("" + this.ediTime[0].getTime() / 1000);
        params['validEnd'] = parseInt("" + this.ediTime[1].getTime() / 1000) + 86400; /*结尾+1天*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getActivityList,params,headers).then(res => {
        console.log("getActivityList：",res.data.data);
        this.li_user = res.data.data["list"];
        this.total = res.data.data.total;
        this.init_View();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取活动数据失败");
        }
      });
    },
    upState(row,stateId){
      this.id = row.id;
      this.stateId = stateId;
      if(stateId === 4) {
        this.daiCleanActivity = true;
        return;
      }
      const params = {
        'id':row.id,
        'stateId':stateId,  /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.changeActivityState,params,headers).then(res => {
        console.log(res.data.data);
        if(stateId === 1) {
          this.$message.success("下线成功");
        } else if(stateId === 2) {
          this.$message.success("发布成功");
        } else if(stateId === 3) {
          this.$message.success("取消成功");
        }
        this.getActivity();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("修改失败");
        }
      });
    },
    cleanUser(){
      const params = {
        'id':this.id,
        'stateId':this.stateId,  /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.changeActivityState,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("取消成功");
        this.daiCleanActivity = false;
        this.getActivity();
      }).catch(error => {
        console.log(error);
        this.daiCleanActivity = false;
        if(error) {
          this.$message.error("取消失败");
        }
      });
    },
    onDelActivity(row){
      this.id = row.id;
      this.daiDelActivity = true;
    },
    delUser(){
      const params = {
        'id':this.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delActivity,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daiDelActivity = false;
        if(this.total % this.pageSize === 1 && this.page !== 1) { /*只有一台时回退页面*/
          this.page -= 1;
        }
        this.getActivity();
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("删除失败");
        }
      });
    },
    timestampToTime(timestamp){/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return Y + M + D + h + m;
      //return Y + M + D + h + m + s;
    },
    init_View(){
      let data = this.li_user;
      let li_d = [];
      for(let i = 0; i < data.length; i++) {
        let startT = this.timestampToTime(data[i]['validStart'] * 1000);
        let endT = this.timestampToTime(data[i]['validEnd'] * 1000);
        let d = {
          id:data[i]['id'],
          title:data[i]['title'],
          user:data[i]['user'],
          times1:`${startT} - ${endT}`,
          times2:this.timestampToTime(data[i]['pubTime'] * 1000),
          top:data[i]['top'],
          number:data[i]['number'],
          state:"",
          imgUrl:""
        };
        if(data[i]['sysUser']) {
          d.user = data[i]['sysUser']['userName'];
        }
        if(data[i]['coverFile']) {
          d.imgUrl = `${this.$urls.ip}/${data[i]['coverFile'].url}`;
        }
        switch(data[i].stateId) {
          case 1:
            d.state = "未发布";
            break;
          case 2:
            d.state = "未开始";
            break;
          case 3:
            d.state = "进行中";
            break;
          case 4:
            d.state = "已取消";
            break;
          case 5:
            d.state = "已结束";
            break;
        }
        li_d.push(d);
      }
      this.tabData = li_d;
    }
  },
  mounted(){ /*页面加载时调用*/
    this.getActivity();
  },
  beforeDestroy(){ /*页面结束时调用*/

  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData(){
      return this.tabData.filter(item => {
        this.state = true;
        // if (this.edi_auth && item.authorityId !== this.edi_auth) {
        //   this.state = false
        // }
        // if (this.scan_user && !item.userName.includes(this.scan_user)) {
        //   this.state = false
        // }
        // if (this.edi_status) {
        //   if (this.edi_status.includes("启用")) {
        //     if (!item.userState) {
        //       this.state = false
        //     }
        //   } else {
        //     if (item.userState) {
        //       this.state = false
        //     }
        //   }
        // }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  }
};
</script>

<style>
#ActivityGl {
  height: 100vh;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 60px;
  border-radius: 5px 5px 5px 5px;
}

.tab_adb {
  user-select: text;

  .gutter {
    /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important;
    /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/ActivityGl.vue